import { z } from 'zod'
import { envelopeSchema } from '../envelope'

export const Instant = z.iso.datetime()
export const Id = z.uuid()
export const Ratio = z.number().min(0).max(1)

export const Readiness = z.object({ status: z.literal('ready') })
export type Readiness = z.infer<typeof Readiness>

export const itemEnvelope = <T extends z.ZodType>(item: T) => envelopeSchema(item)
export const listEnvelope = <T extends z.ZodType>(item: T) => envelopeSchema(z.array(item))
